var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconDiamondLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0948 11.4177C12.276 11.1184 12.6004 10.9355 12.9503 10.9355H20.3803C20.7013 10.9355 21.0029 11.0897 21.1909 11.3499C21.3789 11.6101 21.4305 11.9448 21.3297 12.2496L19.2097 18.6596C19.0743 19.069 18.6916 19.3456 18.2603 19.3456H9.07031C8.70934 19.3456 8.37639 19.151 8.19916 18.8366C8.02192 18.5221 8.02791 18.1365 8.21483 17.8277L12.0948 11.4177ZM13.5139 12.9355L10.8445 17.3456H17.5378L18.9963 12.9355H13.5139Z",
    fill: "#121619"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.8102 11.3493C26.9983 11.0894 27.2996 10.9355 27.6204 10.9355H35.0504C35.4002 10.9355 35.7247 11.1184 35.9059 11.4177L39.7859 17.8277C39.9728 18.1365 39.9788 18.5221 39.8015 18.8366C39.6243 19.151 39.2913 19.3456 38.9304 19.3456H29.7304C29.2986 19.3456 28.9155 19.0684 28.7805 18.6582L26.6705 12.2482C26.5702 11.9435 26.6222 11.6092 26.8102 11.3493ZM29.0023 12.9355L30.454 17.3456H37.1561L34.4867 12.9355H29.0023Z",
    fill: "#121619"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.17488 17.9004C8.34387 17.5605 8.69073 17.3456 9.07032 17.3456H18.2603C18.705 17.3456 19.0962 17.6391 19.2205 18.0661L24.9605 37.7861C25.0953 38.2492 24.8803 38.7425 24.4493 38.9591C24.0183 39.1756 23.4942 39.0537 23.203 38.6692L8.27304 18.9492C8.04392 18.6465 8.00589 18.2403 8.17488 17.9004ZM11.0817 19.3456L21.5249 33.1393L17.5099 19.3456H11.0817Z",
    fill: "#121619"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.7701 18.0665C28.8942 17.6394 29.2856 17.3456 29.7304 17.3456H38.9304C39.31 17.3456 39.6568 17.5605 39.8258 17.9004C39.9948 18.2403 39.9568 18.6465 39.7276 18.9492L24.7976 38.6692C24.5066 39.0536 23.9825 39.1756 23.5516 38.9592C23.1206 38.7428 22.9055 38.2496 23.0401 37.7865L28.7701 18.0665ZM30.4812 19.3456L26.4715 33.1449L36.919 19.3456H30.4812Z",
    fill: "#121619"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.4308 11.6215C19.5663 11.2121 19.949 10.9355 20.3803 10.9355H27.6203C28.0521 10.9355 28.4351 11.2127 28.5701 11.6229L30.6801 18.0329C30.7804 18.3376 30.7285 18.6719 30.5404 18.9318C30.3524 19.1917 30.051 19.3456 29.7303 19.3456H18.2603C17.9392 19.3456 17.6377 19.1914 17.4497 18.9312C17.2617 18.671 17.21 18.3363 17.3108 18.0315L19.4308 11.6215ZM21.1028 12.9355L19.6443 17.3456H28.3483L26.8966 12.9355H21.1028Z",
    fill: "#121619"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDiamondLight);
export default __webpack_public_path__ + "static/media/icon_diamond_light.47bd7dd5.svg";
export { ForwardRef as ReactComponent };